import React from 'react';
import { Play, ExternalLink, Share2 } from 'lucide-react';
import { videos } from '../data/mock';

const VideoSection = () => {
  const shareUrl = encodeURIComponent('https://sklep.eduko.pl/products/zosia-mala-nauczycielka-interaktywny-robot-edukacyiny');
  const shareTitle = encodeURIComponent('Zosia mała nauczycielka - robot edukacyjny mówiący po polsku!');
  const shareText = encodeURIComponent('Zobacz Zosię - jedyny robot edukacyjny mówiący po polsku pełnymi zdaniami! Idealny do nauki kodowania STEAM w przedszkolach i szkołach.');

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-slate-900 mb-4">
            Zobacz{' '}
            <span className="bg-gradient-to-r from-orange-600 to-amber-600 bg-clip-text text-transparent">
              Zosię w akcji
            </span>
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            Przekonaj się jak łatwo i intuicyjnie działa Zosia mała nauczycielka
          </p>
        </div>

        {/* Video grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {videos.tutorials.map((video) => (
            <div
              key={video.id}
              className="group relative bg-slate-50 rounded-2xl overflow-hidden hover:shadow-2xl transition-all duration-300 border border-slate-100"
            >
              {/* Video thumbnail/embed */}
              <div className="relative aspect-video bg-slate-200">
                <iframe
                  src={video.url}
                  title={video.title}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  className="w-full h-full"
                ></iframe>
              </div>

              {/* Content */}
              <div className="p-6">
                <h3 className="text-lg font-bold text-slate-900 mb-2 group-hover:text-orange-600 transition-colors">
                  {video.title}
                </h3>
                <p className="text-slate-600 text-sm">
                  {video.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Share buttons */}
        <div className="mt-12 flex flex-col items-center space-y-4">
          <div className="flex items-center space-x-2 text-slate-600">
            <Share2 className="w-5 h-5" />
            <span className="font-medium">Podziel się z innymi nauczycielami</span>
          </div>
          <div className="flex items-center space-x-3">
            {/* Facebook */}
            <a
              href={`https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center w-12 h-12 bg-[#1877F2] hover:bg-[#166FE5] text-white rounded-full shadow-lg hover:shadow-xl transform hover:scale-110 transition-all duration-300"
              title="Udostępnij na Facebook"
            >
              <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
              </svg>
            </a>
            {/* Email */}
            <a
              href={`mailto:?subject=${shareTitle}&body=${shareText}%0A%0A${shareUrl}`}
              className="flex items-center justify-center w-12 h-12 bg-gradient-to-r from-orange-500 to-amber-500 hover:from-orange-600 hover:to-amber-600 text-white rounded-full shadow-lg hover:shadow-xl transform hover:scale-110 transition-all duration-300"
              title="Wyślij emailem"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
            </a>
          </div>
        </div>

        {/* CTA to YouTube channel */}
        <div className="mt-8 text-center">
          <a
            href="https://www.youtube.com/playlist?list=PLB-YwygSsjGR0NIGsj9h4jUxyDaUyxUQE"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center space-x-2 px-6 py-3 bg-slate-900 hover:bg-slate-800 text-white rounded-xl font-medium shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300"
          >
            <Play className="w-5 h-5" />
            <span>Zobacz więcej filmów na YouTube</span>
            <ExternalLink className="w-4 h-4" />
          </a>
        </div>

        {/* Facebook Community Section */}
        <div className="mt-16 bg-gradient-to-br from-[#1877F2]/10 to-[#1877F2]/5 rounded-3xl p-8 sm:p-12 border border-[#1877F2]/20">
          <div className="flex flex-col lg:flex-row items-center justify-between gap-8">
            <div className="text-center lg:text-left">
              <div className="flex items-center justify-center lg:justify-start space-x-3 mb-4">
                <div className="w-14 h-14 bg-[#1877F2] rounded-2xl flex items-center justify-center shadow-lg">
                  <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                  </svg>
                </div>
                <h3 className="text-2xl sm:text-3xl font-bold text-slate-900">
                  Dołącz do społeczności!
                </h3>
              </div>
              <p className="text-lg text-slate-600 max-w-xl">
                Grupa <span className="font-semibold text-[#1877F2]">"Zosia mała nauczycielka"</span> na Facebooku 
                to miejsce, gdzie nauczyciele dzielą się inspiracjami, pomysłami na zajęcia i swoimi doświadczeniami z Zosią.
              </p>
              <div className="mt-4 flex flex-wrap items-center justify-center lg:justify-start gap-4 text-sm text-slate-500">
                <span className="flex items-center space-x-1">
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M9 6a3 3 0 11-6 0 3 3 0 016 0zM17 6a3 3 0 11-6 0 3 3 0 016 0zM12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 00-1.5-4.33A5 5 0 0119 16v1h-6.07zM6 11a5 5 0 015 5v1H1v-1a5 5 0 015-5z"/>
                  </svg>
                  <span>Setki nauczycieli</span>
                </span>
                <span className="flex items-center space-x-1">
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M18 5v8a2 2 0 01-2 2h-5l-5 4v-4H4a2 2 0 01-2-2V5a2 2 0 012-2h12a2 2 0 012 2zM7 8H5v2h2V8zm2 0h2v2H9V8zm6 0h-2v2h2V8z" clipRule="evenodd"/>
                  </svg>
                  <span>Codzienne inspiracje</span>
                </span>
                <span className="flex items-center space-x-1">
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/>
                  </svg>
                  <span>Gotowe pomysły na zajęcia</span>
                </span>
              </div>
            </div>
            <a
              href="https://www.facebook.com/Zosiamałanauczycielka"
              target="_blank"
              rel="noopener noreferrer"
              className="flex-shrink-0 inline-flex items-center space-x-3 px-8 py-4 bg-[#1877F2] hover:bg-[#166FE5] text-white rounded-2xl font-semibold text-lg shadow-xl hover:shadow-2xl transform hover:scale-105 transition-all duration-300"
            >
              <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
              </svg>
              <span>Dołącz do grupy</span>
              <ExternalLink className="w-5 h-5" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VideoSection;
